import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto } from '@/Domain/api/Action/dto/Action.dto';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { TierEnum } from '@/Domain/enum/Tier.enum';

const ACTION_CREATE_LIMIT = 15;
const ACTION_ACTIVE_LIMIT: Partial<Record<TierEnum, number>> = {
  [TierEnum.BASIC]: 2,
  [TierEnum.TRIAL]: 1,
  [TierEnum.LEGACY_LITE]: 1,
  [TierEnum.LEGACY_ADDONS]: 1,
  [TierEnum.ESSENTIAL]: 3,
  [TierEnum.PROFESSIONAL]: 5,
  [TierEnum.BUSINESS]: 15,
  [TierEnum.CUSTOM]: 15,
  // New pricing (mirrors ai_actions in pricing_plans.yaml).
  [TierEnum.FREE]: 1,
  [TierEnum.STARTER]: 2,
  [TierEnum.BASIC_2026]: 3,
  [TierEnum.ESSENTIAL_2026]: 5,
  [TierEnum.PROFESSIONAL_2026]: 10,
  [TierEnum.BUSINESS_2026]: 15,
};

export const useActionLimit = () => {
  const subscription = useSubscription();

  const { data: actions } = useQuery<ActionDto[]>({
    queryKey: [QueryKey.actions.basic.list],
  });
  const activeActions = (actions || []).filter((action) => action.is_active);

  const activeLimit = ACTION_ACTIVE_LIMIT[subscription.getConfig('tier') as TierEnum] || 1;

  const hasReachedLimit = subscription.isFetched && activeActions.length >= activeLimit;
  const tierLimit = activeLimit - activeActions.length;

  return {
    tierLimit,
    activeLimit,
    hasReachedLimit,
    createLimit: ACTION_CREATE_LIMIT,
    isFetched: subscription.isFetched,
  };
};
